import { render, staticRenderFns } from "./Fotter.vue?vue&type=template&id=1d57a3bf&scoped=true"
import script from "./Fotter.vue?vue&type=script&lang=js"
export * from "./Fotter.vue?vue&type=script&lang=js"
import style0 from "./Fotter.vue?vue&type=style&index=0&id=1d57a3bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d57a3bf",
  null
  
)

export default component.exports